import { PhoneCountry } from './types';

export const COUNTRIES: { [key: string]: PhoneCountry } = {
  Казахстан: { value: 'kz', phonePrefix: '+7', phoneMask: '(###) ### ## ##' },
  Узбекистан: { value: 'uz', phonePrefix: '+998', phoneMask: '(##) ### ## ##' },
} as const;

export function detectPrefixByPhoneNumber(phoneNumber: string) {
  for (const countryName in COUNTRIES) {
    const country = COUNTRIES[countryName];

    if (phoneNumber.startsWith(country.phonePrefix)) return country.phonePrefix;
  }

  return COUNTRIES['Казахстан']?.phonePrefix || '';
}

/** Разбор номера на код страны и абонентскую часть: у КЗ она 10-значная, у УЗ 9-значная. */
export function splitPhoneByCountry(phone?: string | null) {
  const normalized = normalizeIncomingPhoneNumber(phone ?? '');
  const prefix = detectPrefixByPhoneNumber(normalized);

  return { prefix, digits: phone ? excludePrefixFromPhoneNumber(normalized).replaceAll(/\D/g, '') : '' };
}

/** Есть ли в номере явный код страны — тогда он важнее контура оператора. */
export function hasKnownPrefix(phoneNumber: string) {
  return Object.values(COUNTRIES).some((country) => phoneNumber.startsWith(country.phonePrefix));
}

/** Код страны по контуру Октела: номер в местном формате идёт без кода, различить его можно только контуром. */
export function detectPrefixByContour(contour?: string | null) {
  const found = Object.values(COUNTRIES).find((country) => country.value === contour?.toLowerCase());

  return found?.phonePrefix || COUNTRIES['Казахстан']?.phonePrefix || '';
}

export function detectCountryByPrefix(phonePrefix: string) {
  const foundCountry = Object.values(COUNTRIES).find((country) => country.phonePrefix === phonePrefix);

  return foundCountry || COUNTRIES['Казахстан'];
}

export function detectMaskByPrefix(phonePrefix: string) {
  for (const countryName in COUNTRIES) {
    const country = COUNTRIES[countryName];

    if (country.phonePrefix === phonePrefix) return country.phoneMask;
  }

  return '';
}

export function excludePrefixFromPhoneNumber(phoneNumber: string) {
  const phonePrefix = detectPrefixByPhoneNumber(phoneNumber);

  if (phonePrefix) return phoneNumber.replace(phonePrefix.trim(), '').replace(/\s+/g, ' ').trim();

  return phoneNumber;
}

/**
 * АОН из Октела приходит в форме контура: казахстанский отдаёт 8XXXXXXXXXX без плюса,
 * узбекский — номер с кодом страны. Приводим к виду +<код><номер>, по нему уже ищется префикс.
 */
export function normalizeIncomingPhoneNumber(phoneNumber: string) {
  const digits = phoneNumber.replaceAll(/\D/g, '');

  if (digits.length === 11 && digits.startsWith('8')) return `+7${digits.slice(1)}`;
  if (digits.length === 10) return `+7${digits}`;

  return `+${digits}`;
}
